import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import home from "../pages/home.vue";
import single from "../pages/single.vue";

import {item} from "../modules/utils";

const routes = [
	{path: "/", name: "home", component: home, meta: {title: "Home"}},
	{
		path: "/:catId/:id",
		name: "single",
		component: single,
		beforeEnter(to, from, next) {
			const _item = item(to.params.catId, to.params.id);
			if (!_item) return router.push({name: "home"});

			to.meta.item = _item;
			to.meta.title = _item.title;

			next();
		}
	},
	{path: "*", redirect: {name: "home"}}
];

const router = new VueRouter({
	mode: "history",
	routes
});

router.afterEach((to) => {
	// wait for document.title to be updated
	Vue.nextTick(() => {
		fathom("trackPageview");
		goatevent({path: location.host + to.path});
	});
});

export default router;
